<template>
  <article>
    <section class="tip-result">
      <i class="result-ico icon-tipico-ok"></i>
      <p class="result-hd">车辆已提交，请等待开拍</p>
    </section>
    <group class="auction-manage">
      <cell :title="info.store_name" class="v-title">
        <div slot="value" class="fs26">{{info.auction_session.name.substr(5)}}</div>
      </cell>
      <cell :title="info.auction_car.car_model_name" :bdStart="bdStart" class="v-height-tit">
        <div slot="after-title" class="vux-label-desc">
          {{info.auction_car.location_city}} | {{info.auction_car.licensed_issued_on ? info.auction_car.licensed_issued_on.substring(0, 4) + '年' : '未知'}}  | {{info.auction_car.mileage}}公里
        </div>
        <div slot="after-title" class="vux-label-desc" style="color:#fb3f3f;">
          {{(info.minimum_price / 1000000).toFixed(2)}}万起拍
        </div>
        <div class="service-icon" slot="icon">
          <img :src="info.auction_car.car_image_url">
        </div>
      </cell>
    </group>

    <cell :title="'该车将排在 '+info.auction_session.name+' 第 '+info.sequence+' 台'"
          class="bg-dfe4f0-h80 mt20 fs26">
      <div slot="icon"><img src="../../stylesheets/images/manage/horn.png" style="width: 15px;margin-right: 12px;"></div>
    </cell>
    <!--div class="tip-sub">点击右上角的分享，分享给已关注“车安家合作伙伴”<br>的微信好友或微信群</div-->
  </article>
</template>
<script>
// 提交拍卖成功页
import { Cell, Group } from '@lx-frontend/cvux'
import cache from '../../common/cache'
export default {
  components: {
    Cell,
    Group
  },
  data() {
    return {
      bdStart: true,
      sessionKey: 'AUCTION_CONFIRMED',
      info: {
        auction_session: {
          name: ''
        },
        auction_car: {
          license_at: '',
          license_city: '',
          license_mileage: ''
        }
      }
    }
  },
  created() {
    this.info = cache.getSessionData(this.sessionKey) || this.info
    // let fx = {
    // title: this.info.auction_car.car_model_name,
    // desc: this.info.auction_car.location_city + '|' + this.info.auction_car.licensed_at + '|' + this.info.auction_car.mileage + '公里',
    // link: this.info.mp_share_url,
    // imgUrl: this.info.auction_car.car_image_url
    // }
    // this.$wechat.promise.then(wx => {
    // wx.shareAppMessage(fx)
    // wx.hideOptionMenu ()
    // }, wx => {
    // 抛出异常
    // throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
    // })
  }
}
</script>
<style rel="stylesheet/less" lang="less">
  @w2: 75rem;
  .v-height-tit .weui_cell_primary {
    line-height: 36/@w2;
  }

  .mt20 {
    margin-top: 20/@w2;
  }

  .bg-dfe4f0-h80 {
    background: #dfe4f0;
    height: 80/@w2;
    box-sizing: border-box;
    &:before {
      display: none;
    }
  }
</style>
<style rel="stylesheet/less" scoped lang="less">
  @import "../../stylesheets/modules/manage/index.less";
  .tip-sub {
    position: fixed;
    bottom: 30/75rem;
    text-align: center;
    left: 0;
    right: 0;
    color: #999;
  }
</style>
